import { useContext } from "react";

import { ConfiguratorContext } from "../context";

export const useUniversalBenchmarksConfiguratorContext = () => {
  const context = useContext(ConfiguratorContext);

  if (!context) {
    throw new Error(
      "useAdoptBenchmarksContext can only be used inside AdoptBenchmarksProvider",
    );
  }

  return context;
};
